/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type PaymentMethodType = 0 | 1 | 2;

export const PaymentMethodType = {

    NUMBER_0: 0 as PaymentMethodType,

    NUMBER_1: 1 as PaymentMethodType,

    NUMBER_2: 2 as PaymentMethodType
};

